<template>
  <!-- Table Container Card -->
  <div>
    <form-wizard
      ref="themeSetupForm"
      :title="null"
      :subtitle="null"
      layout="vertical"
      :back-button-text="$t('Previous')"
      :next-button-text="$t('Next')"
      class="wizard-vertical mb-3"
    >

      <!-- General Information tab -->
      <tab-content
        :title="$t('General Information')"
      >
        <validation-observer ref="generalInfoRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('General Information') }}
            </h5>
            <b-row class="match-height">
              <b-col md="6">
                <InputField
                  id="theme-name"
                  v-model="configurationFormData.name"
                  :label="$t('Name')"
                  :placeholder="$t('Enter name')"
                  type="text"
                  for="theme-name"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="prefix"
                  v-model="configurationFormData.prefix"
                  :label="$t('Prefix')"
                  :placeholder="$t('Enter prefix')"
                  type="text"
                  for="prefix"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="email"
                  v-model="configurationFormData.email"
                  :label="$t('Email')"
                  :placeholder="$t('Enter email')"
                  type="email"
                  for="email"
                />
              </b-col>
              <b-col md="6">
                <TextAreaField
                  id="seo-keywords"
                  v-model="configurationFormData.seoKeywords"
                  :label="$t('SEO Keywords')"
                  :placeholder="$t('Enter SEO Keywords')"
                  type="text"
                  for="seo-keywords"
                  rows="3"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="domain-name"
                  v-model="configurationFormData.domainName"
                  :label="$t('Domain Name')"
                  :placeholder="$t('Enter domain name')"
                  type="text"
                  for="domain-name"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="play-store-link"
                  v-model="configurationFormData.playStoreLink"
                  :label="$t('Play Store Link')"
                  :placeholder="$t('Enter play store link')"
                  type="text"
                  for="play-store-link"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="app-store-link"
                  v-model="configurationFormData.appStoreLink"
                  :label="$t('App Store Link')"
                  :placeholder="$t('Enter app store link')"
                  type="text"
                  for="app-store-link"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="preferredFont"
                  v-model="configurationFormData.fontFamily"
                  label="Preferred Fonts"
                  :reduce="option => option.value"
                  :options="preferredFonts"
                  item="label"
                  placeholder="Select preferred font"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="preferredLoginPage"
                  v-model="configurationFormData.preferredLoginPage"
                  label="Preferred Fonts"
                  :reduce="option => option.value"
                  :options="preferredLoginOptions"
                  item="label"
                  placeholder="Select Preferred Login Page"
                />
              </b-col>
            </b-row>
            <h5 class="section-label mb-2 mt-3">
              {{ $t('Color Palette') }}
            </h5>
            <b-row class="match-height mt-2">
              <b-col
                md="6"
              >
                <InputField
                  id="theme-primary-color"
                  v-model="configurationFormData.themePrimaryColor"
                  :label="$t('Theme Primary Color')"
                  :placeholder="$t('Enter theme primary color')"
                  type="color"
                  for="theme-primary-color"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="theme-light-primary-color"
                  v-model="configurationFormData.themeLightPrimaryColor"
                  :label="$t('Theme Light Primary Color')"
                  :placeholder="$t('Enter theme light primary color')"
                  type="color"
                  for="theme-light-primary-color"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="theme-secondary-color"
                  v-model="configurationFormData.themeSecondaryColor"
                  :label="$t('Theme Secondary Color')"
                  :placeholder="$t('Enter theme secondary color')"
                  type="color"
                  for="theme-secondary-color"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="theme-light-secondary-color"
                  v-model="configurationFormData.themeLightSecondaryColor"
                  :label="$t('Theme Light Secondary Color')"
                  :placeholder="$t('Enter theme light secondary color')"
                  type="color"
                  for="theme-light-secondary-color"
                />
              </b-col>
              <!-- <b-col md="6">
                <InputField
                  id="theme-disabled-element-primary-color"
                  v-model="configurationFormData.themeDisabledElementPrimaryColor"
                  label="Theme Disabled Element Primary Color"
                  placeholder="Enter theme disabled primary color"
                  type="color"
                  for="theme-disabled-element-primary-color"
                />
              </b-col> -->
            </b-row>
            <h5 class="section-label mb-2 mt-3">
              {{ $t('Support Information') }}
            </h5>
            <b-row>
              <b-col md="6">
                <InputField
                  id="facebook-link"
                  v-model="configurationFormData.facebook"
                  :label="$t('Facebook')"
                  :placeholder="$t('Enter facebook link')"
                  type="text"
                  for="facebook-link"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="instagram-link"
                  v-model="configurationFormData.instagram"
                  :label="$t('Instagram')"
                  :placeholder="$t('Enter instagram link')"
                  type="text"
                  for="instagram-link"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="twitter-link"
                  v-model="configurationFormData.twitter"
                  :label="$t('Twitter')"
                  :placeholder="$t('Enter twitter link')"
                  type="text"
                  for="twitter-link"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="website-link"
                  v-model="configurationFormData.websiteUrl"
                  :label="$t('Website')"
                  :placeholder="$t('Enter website link')"
                  type="text"
                  for="website-link"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="support-email"
                  v-model="configurationFormData.supportEmail"
                  :label="$t('Support Email')"
                  :placeholder="$t('Enter support email')"
                  type="email"
                  for="support-email"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="support-phone-number"
                  v-model="configurationFormData.supportPhoneNumber"
                  :label="$t('Support Phone Number')"
                  :placeholder="$t('Enter phone number')"
                  type="text"
                  for="support-phone-number"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="whatsapp-number"
                  v-model="configurationFormData.whatsappNumber"
                  :label="$t('WhatsApp Phone Number')"
                  :placeholder="$t('Enter whatsapp number')"
                  type="text"
                  for="whatsapp-number"
                />
              </b-col>
              <b-col md="12">
                <TextAreaField
                  id="address"
                  v-model="configurationFormData.address"
                  :label="$t('Address')"
                  :placeholder="$t('Enter Address')"
                  type="text"
                  for="address"
                  rows="3"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Login Page Image tab -->
      <tab-content
        :title="$t('Login Page Image')"
      >
        <validation-observer ref="loginPageRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Login Page Image') }}
            </h5>
            <b-row class="match-height">
              <b-col md="6">
                <label> {{ $t('Login Page Image') }}
                  <feather-icon
                    icon="InfoIcon"
                    size="20"
                    class="text-primary ml-1"
                    @click="showModal('modal-login-page-info')"
                  />
                </label>
                <Spinner :show="loginPageImageUrlLoadSpinner" />
                <div class="upload-image-loginPageImageURL">
                  <b-form-group>
                    <b-form-file
                      v-model="loginPageImageUrl"
                      :state="Boolean(loginPageImageUrl)"
                      :placeholder="$t('Choose a file or drop it here...')"
                      :drop-placeholder="$t('Drop file here...')"
                      accept="image/jpeg, image/png, image/jpg"
                      plain
                      @change="onLoginPageImageUrlUpload"
                    />
                    <div
                      v-if="!hasLoginPageImageURL && !configurationFormData.loginPageImageURL"
                      class="upload-instruction"
                    >
                      <h4> {{ $t('Upload Login Page Image URL') }} </h4>
                      <p> {{ $t('Drag & drop file or choose from your device to upload') }} </p>
                      <p class="format">
                        {{ $t('Format accepted (jpg, png, jpeg)') }} <br>
                        {{ $t('Image dimension: 720 x 1024') }}
                      </p>
                    </div>
                    <b-img
                      v-else
                      :src="configurationFormData.loginPageImageURL"
                      block
                      fluid
                      rounded
                    />

                    <b-img
                      v-if="hasLoginPageImageURL"
                      :src="loginPageImageUrlSrc"
                      block
                      fluid
                      rounded
                    />
                    <div
                      v-if="hasLoginPageImageURL || configurationFormData.loginPageImageURL"
                      class="trash"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-primary"
                        @click="clearLoginPageImageUrl"
                      />
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Logo Image tab-->
      <tab-content
        :title="$t('Logo Image')"
      >
        <validation-observer ref="logoImageRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Logo Image') }}
            </h5>
            <b-row class="match-height">
              <b-col
                md="6"
                class="mt-2"
              >

                <b-col class="md-6">
                  <label> {{ $t('Logo Image') }}
                    <feather-icon
                      icon="InfoIcon"
                      size="20"
                      class="text-primary ml-1"
                      @click="showModal('modal-logo-image-info')"
                    />
                  </label>
                </b-col>
                <Spinner :show="logoURLLoadSpinner" />
                <div class="upload-image-logoImageURL">
                  <b-form-group>
                    <b-form-file
                      v-model="logoURL"
                      :state="Boolean(logoURL)"
                      :placeholder="$t('Choose a file or drop it here...')"
                      :drop-placeholder="$t('Drop file here...')"
                      accept="image/jpeg, image/png, image/jpg"
                      plain
                      @change="onLogoURLUpload"
                    />
                    <div
                      v-if="!hasLogoURL && !configurationFormData.logoURL"
                      class="upload-instruction"
                    >
                      <h4> {{ $t('Upload Logo URL') }} </h4>
                      <p> {{ $t('Drag & drop file or choose from your device to upload') }} </p>
                      <p class="format">
                        {{ $t('Format accepted (jpg, png, jpeg)') }}
                        <br>
                        {{ $t('Image dimension: 200 x 200') }}
                      </p>
                    </div>
                    <b-img
                      v-else
                      :src="configurationFormData.logoURL"
                      block
                      fluid
                      rounded
                    />

                    <b-img
                      v-if="hasLogoURL"
                      :src="logoURLSrc"
                      block
                      fluid
                      rounded
                    />
                    <div
                      v-if="hasLogoURL || configurationFormData.logoURL"
                      class="trash"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-primary"
                        @click="clearLogoURL"
                      />
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Onboarding Navigation Background Image tab-->
      <tab-content
        :title="$t('Onboarding Nav Image')"
      >
        <validation-observer ref="onboardingNavigationRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Onboarding Navigation Background Image') }}
            </h5>
            <b-row class="match-height">
              <b-col
                md="6"
                class="mt-2"
              >
                <label> {{ $t('Onboarding Nav Background Image') }}
                  <feather-icon
                    icon="InfoIcon"
                    size="20"
                    class="text-primary ml-1"
                    @click="showModal('modal-onboarding-image-info')"
                  />
                </label>
                <Spinner :show="onboardingNavBackgroundImageURLLoadSpinner" />
                <div class="upload-image-OnboardingNavBackgroundImageURL">
                  <b-form-group>
                    <b-form-file
                      v-model="onboardingNavBackgroundImageURL"
                      :state="Boolean(onboardingNavBackgroundImageURL)"
                      :placeholder="$t('Choose a file or drop it here...')"
                      :drop-placeholder="$t('Drop file here...')"
                      accept="image/jpeg, image/png, image/jpg"
                      plain
                      @change="onOnboardingNavBackgroundImageURLUpload"
                    />
                    <div
                      v-if="!hasOnboardingNavBackgroundImageURL && !configurationFormData.onboardingNavBackgroundImageURL"
                      class="upload-instruction"
                    >
                      <h4> {{ $t('Upload Onboarding Nav Background Image URL') }} </h4>
                      <p> {{ $t('Drag & drop file or choose from your device to upload') }} </p>
                      <p class="format">
                        {{ $t('Format accepted (jpg, png, jpeg)') }} <br>
                        {{ $t('Image dimension: 400 x 1024') }}
                      </p>
                    </div>
                    <b-img
                      v-else
                      :src="configurationFormData.onboardingNavBackgroundImageURL"
                      block
                      fluid
                      rounded
                    />

                    <b-img
                      v-if="hasOnboardingNavBackgroundImageURL"
                      :src="onboardingNavBackgroundImageURLSrc"
                      block
                      fluid
                      rounded
                    />
                    <div
                      v-if="hasOnboardingNavBackgroundImageURL || configurationFormData.onboardingNavBackgroundImageURL"
                      class="trash"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-primary"
                        @click="clearOnboardingNavBackgroundImageURL"
                      />
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Favicon Image tab-->
      <tab-content
        :title="$t('Favicon Image')"
      >
        <validation-observer ref="faviconImageRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Favicon Image') }}
            </h5>
            <b-row class="match-height mb-2 mt-1">
              <b-col
                md="6"
                class="mt-2"
              >
                <label> {{ $t('Favicon Image') }}
                  <feather-icon
                    icon="InfoIcon"
                    size="20"
                    class="text-primary ml-1"
                    @click="showModal('modal-favicon-image-info')"
                  />
                </label>
                <Spinner :show="faviconURLLoadSpinner" />
                <div class="upload-image-faviconImageURL">
                  <b-form-group>
                    <b-form-file
                      v-model="faviconURL"
                      :state="Boolean(faviconURL)"
                      :placeholder="$t('Choose a file or drop it here...')"
                      :drop-placeholder="$t('Drop file here...')"
                      accept="image/jpeg, image/png, image/jpg"
                      plain
                      @change="onFaviconURLUpload"
                    />
                    <div
                      v-if="!hasFaviconURL && !configurationFormData.faviconURL"
                      class="upload-instruction"
                    >
                      <h4> {{ $t('Upload Favicon URL') }} </h4>
                      <p> {{ $t('Drag & drop file or choose from your device to upload') }} </p>
                      <p class="format">
                        {{ $t('Format accepted (jpg, png, jpeg)') }} <br>
                        {{ $t('Image dimension: 16 x 16') }}
                      </p>
                    </div>
                    <b-img
                      v-else
                      :src="configurationFormData.faviconURL"
                      block
                      fluid
                      rounded
                    />

                    <b-img
                      v-if="hasFaviconURL"
                      :src="faviconURLSrc"
                      block
                      fluid
                      rounded
                    />
                    <div
                      v-if="hasFaviconURL || configurationFormData.faviconURL"
                      class="trash"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-primary"
                        @click="clearFaviconURL"
                      />
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Left & Right Banner Image tab-->
      <tab-content
        :title="$t('Left & Right Banner')"
      >
        <validation-observer ref="leftRightBannerImageRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Left And Right Banner Image') }}
            </h5>
            <b-row class="match-height mb-2 mt-1">
              <b-col
                md="6"
                class="mt-2"
              >
                <label> {{ $t('Left Banner Image') }}
                  <feather-icon
                    icon="InfoIcon"
                    size="20"
                    class="text-primary ml-1"
                    @click="showModal('modal-left_right-banner-image-info')"
                  />
                </label>
                <Spinner :show="leftBannerImageURLLoadSpinner" />
                <div class="upload-left-right-banner-ImageURL">
                  <b-form-group>
                    <b-form-file
                      v-model="leftBannerImageURL"
                      :state="Boolean(leftBannerImageURL)"
                      :placeholder="$t('Choose a file or drop it here...')"
                      :drop-placeholder="$t('Drop file here...')"
                      accept="image/jpeg, image/png, image/jpg"
                      plain
                      @change="onLeftBannerImageURLUpload"
                    />
                    <div
                      v-if="!hasLeftBannerImageURL && !configurationFormData.leftBannerImageURL"
                      class="upload-instruction"
                    >
                      <h4> {{ $t('Upload Left Banner Image') }} </h4>
                      <p> {{ $t('Drag & drop file or choose from your device to upload') }} </p>
                      <p class="format">
                        {{ $t('Format accepted (jpg, png, jpeg)') }} <br>
                        {{ $t('Image dimension: 296 x 864') }}
                      </p>
                    </div>
                    <b-img
                      v-else
                      :src="configurationFormData.leftBannerImageURL"
                      block
                      fluid
                      rounded
                    />

                    <b-img
                      v-if="hasLeftBannerImageURL"
                      :src="leftBannerImageURLSrc"
                      block
                      fluid
                      rounded
                    />
                    <div
                      v-if="hasLeftBannerImageURL || configurationFormData.leftBannerImageURL"
                      class="trash"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-primary"
                        @click="clearLeftBannerImageURL"
                      />
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <b-col
                md="6"
                class="mt-2"
              >
                <label> {{ $t('Right Banner Image') }}
                  <feather-icon
                    icon="InfoIcon"
                    size="20"
                    class="text-primary ml-1"
                    @click="showModal('modal-left_right-banner-image-info')"
                  />
                </label>
                <Spinner :show="rightBannerImageURLLoadSpinner" />
                <div class="upload-left-right-banner-ImageURL">
                  <b-form-group>
                    <b-form-file
                      v-model="rightBannerImageURL"
                      :state="Boolean(rightBannerImageURL)"
                      :placeholder="$t('Choose a file or drop it here...')"
                      :drop-placeholder="$t('Drop file here...')"
                      accept="image/jpeg, image/png, image/jpg"
                      plain
                      @change="onRightBannerImageURLUpload"
                    />
                    <div
                      v-if="!hasRightBannerImageURL && !configurationFormData.rightBannerImageURL"
                      class="upload-instruction"
                    >
                      <h4> {{ $t('Upload Right Banner Image') }} </h4>
                      <p> {{ $t('Drag & drop file or choose from your device to upload') }} </p>
                      <p class="format">
                        {{ $t('Format accepted (jpg, png, jpeg)') }} <br>
                        {{ $t('Image dimension: 296 x 864') }}
                      </p>
                    </div>
                    <b-img
                      v-else
                      :src="configurationFormData.rightBannerImageURL"
                      block
                      fluid
                      rounded
                    />

                    <b-img
                      v-if="hasRightBannerImageURL"
                      :src="rightBannerImageURLSrc"
                      block
                      fluid
                      rounded
                    />
                    <div
                      v-if="hasRightBannerImageURL || configurationFormData.rightBannerImageURL"
                      class="trash"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-primary"
                        @click="clearRightBannerImageURL"
                      />
                    </div>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <template
        slot="finish"
      >
        <div class="wizard-footer-right">
          <Button
            :label="buttonAction"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </template>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>
    <b-modal
      id="modal-login-page-info"
      ok-only
      :ok-title="$t('Close')"
      centered
      :title="$t('INSTRUCTION')"
    >
      <b-card-text>
        {{ $t('Please note that the Login Page Image dimension must be') }} <strong> {{ $t('720px width by 1024px height') }} </strong>,
        {{ $t('to corespond to the allocated image dimension on the internet banking.') }}
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-logo-image-info"
      ok-only
      :ok-title="$t('Close')"
      centered
      :title="$t('INSTRUCTION')"
    >
      <b-card-text>
        {{ $t('Please note that the Logo Image dimension must be') }}  <strong> {{ $t('200px width by 200px height') }} </strong>,
        {{ $t('to corespond to the allocated image dimension on the internet banking.') }}
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-onboarding-image-info"
      ok-only
      ok-title="Close"
      centered
      title="INSTRUCTION"
    >
      <b-card-text>
        {{ $t('Please note that the Onboarding Navigation Background Image dimension must be') }} <strong> {{ $t('400px width by 1024px height') }} </strong>,
        {{ $t('to corespond to the allocated image dimension on the internet banking.') }}
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-favicon-image-info"
      ok-only
      :ok-title="$t('Close')"
      centered
      :title="$t('INSTRUCTION')"
    >
      <b-card-text>
        {{ $t('Please note that the Favicon Image dimension must be') }}<strong> {{ $t('16px width by 16px height') }} </strong>,
        {{ $t('to corespond to the allocated image dimension on the internet banking.') }}
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-left_right-banner-image-info"
      ok-only
      :ok-title="$t('Close')"
      centered
      :title="$t('INSTRUCTION')"
    >
      <b-card-text>
        {{ $t('Please note that the Left and Right Banner Image dimension must be') }} <strong> {{ $t('296px width by 864px height') }} </strong> {{ $t('respectively, to corespond to the allocated image dimension on the internet banking.') }}
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup,
  BForm, BFormFile, BImg, BCardText,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required } from '@validations'
import { v4 as uuidv4 } from 'uuid'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { permissionMixin } from '@core/mixins/permission'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Spinner from '@/views/components/spinner/Spinner.vue'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import TextAreaField from '../../../forms/TextAreaField.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Button from '../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../helpers/permissions'
import { preferredFonts, preferredLoginOptions } from '../../../../helpers/data'

const base64Encode = data => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(data)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BFormFile,
    FormWizard,
    TabContent,
    BFormGroup,
    BForm,
    BCardText,
    ValidationObserver,
    InputField,
    SelectField,
    TextAreaField,
    Button,
    FullScreenSpinner,
    Spinner,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      onboardingPageBackgroundUrl: null,
      onboardingPageBackgroundURLSrc: null,
      hasOnboardingPageBackgroundURL: false,
      loginPageImageUrl: null,
      loginPageImageUrlSrc: null,
      hasLoginPageImageURL: false,
      logoURL: null,
      logoURLSrc: null,
      hasLogoURL: false,
      preferredFonts,
      preferredLoginOptions,
      onboardingNavBackgroundImageURL: null,
      onboardingNavBackgroundImageURLSrc: null,
      hasOnboardingNavBackgroundImageURL: false,
      faviconURL: null,
      faviconURLSrc: null,
      hasFaviconURL: false,
      leftBannerImageURL: null,
      leftBannerImageURLSrc: null,
      hasLeftBannerImageURL: false,
      rightBannerImageURL: null,
      rightBannerImageURLSrc: null,
      hasRightBannerImageURL: false,
      isReadonly: true,
      isBusy: false,
      showSpinner: false,
      onboardingPageBackgroundUrlLoadSpinner: false,
      loginPageImageUrlLoadSpinner: false,
      logoURLLoadSpinner: false,
      onboardingNavBackgroundImageURLLoadSpinner: false,
      faviconURLLoadSpinner: false,
      leftBannerImageURLLoadSpinner: false,
      rightBannerImageURLLoadSpinner: false,
      isDisabled: false,
      isLoading: false,
      required,
      buttonAction: this.$t('Save'),
      imageFormData: {
        onboardingPageBackgroundURL: '',
        loginPageImageUrl: '',
        logoURL: '',
        onboardingNavBackgroundImageURL: '',
        faviconURL: '',
        leftBannerImageUrl: '',
        rightBannerImageUrl: '',
      },
      configurationFormData: {
        name: '',
        prefix: '',
        email: '',
        supportEmail: '',
        seoKeywords: '',
        domainName: '',
        playStoreLink: '',
        appStoreLink: '',
        onboardingPageBackgroundURL: '',
        loginPageImageURL: '',
        logoURL: '',
        themePrimaryColor: '',
        themeSecondaryColor: '',
        themeDisabledElementPrimaryColor: '',
        themeLightPrimaryColor: '',
        themeLightSecondaryColor: '',
        onboardingNavBackgroundImageURL: '',
        faviconURL: '',
        leftBannerImageUrl: '',
        rightBannerImageUrl: '',
        facebook: '',
        twitter: '',
        instagram: '',
        whatsappNumber: '',
        address: '',
        supportPhoneNumber: '',
        websiteUrl: '',
        id: '',
        fontFamily: 'Inter',
        preferredLoginPage: 'template-v1',
      },
      imagePath: {
        size: '',
        height: '',
        width: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      branchOptions: 'operations/branchOptions',
    }),
    hasonboardingPageBackgroundURL: {
      get() {
        return !!this.onboardingPageBackgroundURL
      },
      set(onboardingPageBackgroundURL) {
        return onboardingPageBackgroundURL
      },
    },
    hasloginPageImageURL: {
      get() {
        return !!this.loginPageImageURL
      },
      set(loginPageImageURL) {
        return loginPageImageURL
      },
    },
    haslogoURL: {
      get() {
        return !!this.logoURL
      },
      set(logoURL) {
        return logoURL
      },
    },
    hasonboardingNavBackgroundImageURL: {
      get() {
        return !!this.onboardingNavBackgroundImageURL
      },
      set(onboardingNavBackgroundImageURL) {
        return onboardingNavBackgroundImageURL
      },
    },
    hasfaviconURL: {
      get() {
        return !!this.faviconURL
      },
      set(faviconURL) {
        return faviconURL
      },
    },
    hasleftBannerImageURL: {
      get() {
        return !!this.leftBannerImageURL
      },
      set(leftBannerImageURL) {
        return leftBannerImageURL
      },
    },
    hasrightBannerImageURL: {
      get() {
        return !!this.rightBannerImageURL
      },
      set(rightBannerImageURL) {
        return rightBannerImageURL
      },
    },
  },
  watch: {
    onboardingPageBackgroundURL(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          if (typeof newValue === 'object') {
            base64Encode(newValue)
              .then(value => {
                this.onboardingPageBackgroundURLSrc = value
                this.hasOnboardingPageBackgroundURL = true
              })
              .catch(() => {
                this.onboardingPageBackgroundURLSrc = null
              })
          } else {
            this.onboardingPageBackgroundURLSrc = newValue
          }
        } else {
          this.onboardingPageBackgroundURLSrc = null
        }
      }
    },
    loginPageImageURL(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          if (typeof newValue === 'object') {
            base64Encode(newValue)
              .then(value => {
                this.loginPageImageURLSrc = value
                this.hasloginPageImageURL = true
              })
              .catch(() => {
                this.loginPageImageURLSrc = null
              })
          } else {
            this.loginPageImageURLSrc = newValue
          }
        } else {
          this.loginPageImageURLSrc = null
        }
      }
    },
    logoURL(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          if (typeof newValue === 'object') {
            base64Encode(newValue)
              .then(value => {
                this.logoURLSrc = value
                this.hasLogoURL = false
              })
              .catch(() => {
                this.logoURLSrc = null
              })
          } else {
            this.logoURLSrc = newValue
          }
        } else {
          this.logoURLSrc = null
        }
      }
    },
    onboardingNavBackgroundImageURL(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          if (typeof newValue === 'object') {
            base64Encode(newValue)
              .then(value => {
                this.onboardingNavBackgroundImageURLSrc = value
                this.hasOnboardingNavBackgroundImageURL = false
              })
              .catch(() => {
                this.onboardingNavBackgroundImageURLSrc = null
              })
          } else {
            this.onboardingNavBackgroundImageURLSrc = newValue
          }
        } else {
          this.onboardingNavBackgroundImageURLSrc = null
        }
      }
    },
    faviconURL(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          if (typeof newValue === 'object') {
            base64Encode(newValue)
              .then(value => {
                this.faviconURLSrc = value
                this.hasFaviconURL = false
              })
              .catch(() => {
                this.faviconURLSrc = null
              })
          } else {
            this.faviconURLSrc = newValue
          }
        } else {
          this.faviconURLSrc = null
        }
      }
    },
    leftBannerImageURL(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          if (typeof newValue === 'object') {
            base64Encode(newValue)
              .then(value => {
                this.leftBannerImageURLSrc = value
                this.hasLeftBannerImageURL = false
              })
              .catch(() => {
                this.leftBannerImageURLSrc = null
              })
          } else {
            this.leftBannerImageURLSrc = newValue
          }
        } else {
          this.leftBannerImageURLSrc = null
        }
      }
    },
    rightBannerImageURL(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          if (typeof newValue === 'object') {
            base64Encode(newValue)
              .then(value => {
                this.rightBannerImageURLSrc = value
                this.hasRightBannerImageURL = false
              })
              .catch(() => {
                this.rightBannerImageURLSrc = null
              })
          } else {
            this.rightBannerImageURLSrc = newValue
          }
        } else {
          this.rightBannerImageURLSrc = null
        }
      }
    },
  },
  mounted() {
    this.fetchThemeConfigurationSetup()
    if (this.configurationFormData.id === '') {
      this.buttonAction = this.$t('Save')
    } else {
      this.buttonAction = this.$t('Update')
    }
  },
  methods: {
    ...mapActions({
      getThemeConfigurationSetup: 'eChannels/getThemeConfigurationSetup',
      createThemeConfiguration: 'eChannels/createThemeConfigurationSetupAction',
      updateThemeConfiguration: 'eChannels/updateThemeConfigurationSetupAction',
      uploadImageFile: 'account/uploadImageFileAction',
    }),
    getFontOptionStyle(option) {
      if (option && option.value) {
        return {
          fontFamily: `'${option.value}', sans-serif`,
        }
      }
      return {} // Return an empty style object if option or its value is undefined
    },
    clearLoginPageImageUrl() {
      this.configurationFormData.loginPageImageURL = ''
      this.loginPageImageURL = ''
      this.hasLoginPageImageURL = false
    },
    clearLogoURL() {
      this.configurationFormData.logoURL = ''
      this.logoURL = ''
      this.hasLogoURL = false
    },
    clearOnboardingNavBackgroundImageURL() {
      this.configurationFormData.onboardingNavBackgroundImageURL = ''
      this.onboardingNavBackgroundImageURL = ''
      this.hasOnboardingNavBackgroundImageURL = false
    },
    clearFaviconURL() {
      this.configurationFormData.faviconURL = ''
      this.faviconURL = ''
      this.hasFaviconURL = false
    },
    clearLeftBannerImageURL() {
      this.configurationFormData.leftBannerImageURL = ''
      this.leftBannerImageURL = ''
      this.hasLeftBannerImageURL = false
    },
    clearRightBannerImageURL() {
      this.configurationFormData.rightBannerImageURL = ''
      this.rightBannerImageURL = ''
      this.hasRightBannerImageURL = false
    },
    async onOnboardingNavBackgroundImageURLUpload(event) {
      try {
        this.onboardingNavBackgroundImageURLLoadSpinner = true
        const { target } = event
        // eslint-disable-next-line prefer-destructuring
        this.imageFormData.onboardingNavBackgroundImageURL = target.files[0]

        // Get image width and height sizes
        const MAX_WIDTH = 400
        const MAX_HEIGHT = 1024
        const photoUrl = URL.createObjectURL(this.imageFormData.onboardingNavBackgroundImageURL)
        const image = new Image()
        const imageDimensions = await new Promise(resolve => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            }
            resolve(dimensions)
          }
          image.src = photoUrl
        })
        if (imageDimensions.width < MAX_WIDTH || imageDimensions.width > MAX_WIDTH) {
          const text1 = this.$t('Image width size uploaded is')
          const text2 = this.$t('Image width must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.width}px. ${text2} ${MAX_WIDTH}px` })
        } else if (imageDimensions.height < MAX_HEIGHT || imageDimensions.height > MAX_HEIGHT) {
          const text1 = this.$t('Image height size uploaded is')
          const text2 = this.$t('Image height must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.height}px. ${text2} ${MAX_HEIGHT}px` })
        } else {
          this.configurationFormData.onboardingNavBackgroundImageURL = ''

          const formData = new FormData()
          if (typeof this.imageFormData.onboardingNavBackgroundImageURL !== 'string') {
            formData.append('attachedFile', this.imageFormData.onboardingNavBackgroundImageURL)
            formData.append('filetype', 'Others')
            formData.append('referenceNumber', uuidv4())
          }
          const response = await this.uploadImageFile({ formData, permission: eChannelsPermission.CREATE_THEME })

          const { status, data } = await response
          if (status === 200 && data) {
            this.configurationFormData.onboardingNavBackgroundImageURL = data.url
            this.onboardingNavBackgroundImageURLLoadSpinner = false
          }
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Image upload failed. Reason:')
          this.alertError({ text: `${reasonText} ${responseError.errorMessage}` })
        })
      } finally {
        this.onboardingNavBackgroundImageURLLoadSpinner = false
      }
    },
    async onLoginPageImageUrlUpload(event) {
      try {
        this.loginPageImageUrlLoadSpinner = true
        const { target } = event
        // eslint-disable-next-line prefer-destructuring
        this.imageFormData.loginPageImageURL = target.files[0]

        // // Get image width and height sizes
        // const MAX_WIDTH = 720
        // const MAX_HEIGHT = 1024
        // const photoUrl = URL.createObjectURL(this.imageFormData.loginPageImageURL)
        // const image = new Image()
        // const imageDimensions = await new Promise(resolve => {
        //   image.onload = () => {
        //     const dimensions = {
        //       height: image.height,
        //       width: image.width,
        //     }
        //     resolve(dimensions)
        //   }
        //   image.src = photoUrl
        // })
        // if (imageDimensions.width < MAX_WIDTH || imageDimensions.width > MAX_WIDTH) {
        //   const text1 = this.$t('Image width size uploaded is')
        //   const text2 = this.$t('Image width must be equal to')
        //   this.alertError({ text: `${text1} ${imageDimensions.width}px. ${text2} ${MAX_WIDTH}px` })
        // } else if (imageDimensions.height < MAX_HEIGHT || imageDimensions.height > MAX_HEIGHT) {
        //   const text1 = this.$t('Image height size uploaded is')
        //   const text2 = this.$t('Image height must be equal to')
        //   this.alertError({ text: `${text1} ${imageDimensions.height}px. ${text2} ${MAX_HEIGHT}px` })
        // } else {
        this.configurationFormData.loginPageImageURL = ''
        const formData = new FormData()
        if (typeof this.imageFormData.loginPageImageURL !== 'string') {
          formData.append('attachedFile', this.imageFormData.loginPageImageURL)
          formData.append('type', 'Others')
          formData.append('referenceNumber', uuidv4())
        }
        const response = await this.uploadImageFile({ formData, permission: eChannelsPermission.CREATE_THEME })

        const { status, data } = await response
        if (status === 200 && data) {
          this.configurationFormData.loginPageImageURL = data.url
          this.loginPageImageUrlLoadSpinner = false
        }
        // }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Image upload failed. Reason:')
          this.alertError({ text: `${reasonText} ${responseError.errorMessage}` })
        })
      } finally {
        this.loginPageImageUrlLoadSpinner = false
      }
    },
    async onLogoURLUpload(event) {
      try {
        this.logoURLLoadSpinner = true
        const [file] = event.target.files

        const MIN_WIDTH = 200
        const MAX_WIDTH = 300

        const imageDimensions = await this.getImageDimensions(file)

        if (imageDimensions.width < MIN_WIDTH || imageDimensions.width > MAX_WIDTH) {
          const text1 = this.$t('Image width size uploaded is')
          const text2 = this.$t('Image width must be between')
          const text3 = this.$t('and')
          this.alertError({
            text: `${text1} ${imageDimensions.width}px. ${text2} ${MIN_WIDTH}px ${text3} ${MAX_WIDTH}px`,
          })
          return
        }
        this.configurationFormData.logoURL = ''

        const formData = new FormData()
        if (typeof file !== 'string') {
          formData.append('attachedFile', file)
          formData.append('filetype', 'Others')
          formData.append('referenceNumber', uuidv4())
        }

        const response = await this.uploadImageFile({
          formData,
          permission: eChannelsPermission.CREATE_THEME,
        })

        const { status, data } = await response
        if (status === 200 && data) {
          this.configurationFormData.logoURL = data.url
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Image upload failed. Reason:')
          this.alertError({ text: `${reasonText} ${responseError.errorMessage}` })
        })
      } finally {
        this.logoURLLoadSpinner = false
      }
    },

    // Extracted: resolves image dimensions from a File object
    getImageDimensions(file) {
      return new Promise(resolve => {
        const image = new Image()
        image.onload = () => resolve({ width: image.width, height: image.height })
        image.src = URL.createObjectURL(file)
      })
    },
    async onFaviconURLUpload(event) {
      try {
        this.faviconURLLoadSpinner = true
        const { target } = event
        // eslint-disable-next-line prefer-destructuring
        this.imageFormData.faviconURL = target.files[0]

        // Get image width and height sizes
        const MAX_WIDTH = 16
        const MAX_HEIGHT = 16
        const photoUrl = URL.createObjectURL(this.imageFormData.faviconURL)
        const image = new Image()
        const imageDimensions = await new Promise(resolve => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            }
            resolve(dimensions)
          }
          image.src = photoUrl
        })
        if (imageDimensions.width < MAX_WIDTH || imageDimensions.width > MAX_WIDTH) {
          const text1 = this.$t('Image width size uploaded is')
          const text2 = this.$t('Image width must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.width}px. ${text2} ${MAX_WIDTH}px` })
        } else if (imageDimensions.height < MAX_HEIGHT || imageDimensions.height > MAX_HEIGHT) {
          const text1 = this.$t('Image height size uploaded is')
          const text2 = this.$t('Image height must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.height}px. ${text2} ${MAX_HEIGHT}px` })
        } else {
          this.configurationFormData.faviconURL = ''

          const formData = new FormData()
          if (typeof this.imageFormData.faviconURL !== 'string') {
            formData.append('attachedFile', this.imageFormData.faviconURL)
            formData.append('filetype', 'Others')
            formData.append('referenceNumber', uuidv4())
          }
          const response = await this.uploadImageFile({ formData, permission: eChannelsPermission.CREATE_THEME })

          const { status, data } = await response
          if (status === 200 && data) {
            this.configurationFormData.faviconURL = data.url
            this.faviconURLLoadSpinner = false
          }
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Image upload failed. Reason:')
          this.alertError({ text: `${reasonText} ${responseError.errorMessage}` })
        })
      } finally {
        this.faviconURLLoadSpinner = false
      }
    },
    async onLeftBannerImageURLUpload(event) {
      try {
        this.leftBannerImageURLLoadSpinner = true
        const { target } = event
        // eslint-disable-next-line prefer-destructuring
        this.imageFormData.leftBannerImageURL = target.files[0]

        // Get image width and height sizes
        const MAX_WIDTH = 296
        const MAX_HEIGHT = 864
        const photoUrl = URL.createObjectURL(this.imageFormData.leftBannerImageURL)
        const image = new Image()
        const imageDimensions = await new Promise(resolve => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            }
            resolve(dimensions)
          }
          image.src = photoUrl
        })
        if (imageDimensions.width < MAX_WIDTH || imageDimensions.width > MAX_WIDTH) {
          const text1 = this.$t('Image width size uploaded is')
          const text2 = this.$t('Image width must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.width}px. ${text2} ${MAX_WIDTH}px` })
        } else if (imageDimensions.height < MAX_HEIGHT || imageDimensions.height > MAX_HEIGHT) {
          const text1 = this.$t('Image height size uploaded is')
          const text2 = this.$t('Image height must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.height}px. ${text2} ${MAX_HEIGHT}px` })
        } else {
          this.configurationFormData.leftBannerImageURL = ''

          const formData = new FormData()
          if (typeof this.imageFormData.leftBannerImageURL !== 'string') {
            formData.append('attachedFile', this.imageFormData.leftBannerImageURL)
            formData.append('filetype', 'Others')
            formData.append('referenceNumber', uuidv4())
          }
          const response = await this.uploadImageFile({ formData, permission: eChannelsPermission.CREATE_THEME })

          const { status, data } = await response
          if (status === 200 && data) {
            this.configurationFormData.leftBannerImageURL = data.url
            this.leftBannerImageURLLoadSpinner = false
          }
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Image upload failed. Reason:')
          this.alertError({ text: `${reasonText} ${responseError.errorMessage}` })
        })
      } finally {
        this.leftBannerImageURLLoadSpinner = false
      }
    },

    async onRightBannerImageURLUpload(event) {
      try {
        this.rightBannerImageURLLoadSpinner = true
        const { target } = event
        // eslint-disable-next-line prefer-destructuring
        this.imageFormData.rightBannerImageURL = target.files[0]

        // Get image width and height sizes
        const MAX_WIDTH = 296
        const MAX_HEIGHT = 864
        const photoUrl = URL.createObjectURL(this.imageFormData.rightBannerImageURL)
        const image = new Image()
        const imageDimensions = await new Promise(resolve => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            }
            resolve(dimensions)
          }
          image.src = photoUrl
        })
        if (imageDimensions.width < MAX_WIDTH || imageDimensions.width > MAX_WIDTH) {
          const text1 = this.$t('Image width size uploaded is')
          const text2 = this.$t('Image width must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.width}px. ${text2} ${MAX_WIDTH}px` })
        } else if (imageDimensions.height < MAX_HEIGHT || imageDimensions.height > MAX_HEIGHT) {
          const text1 = this.$t('Image height size uploaded is')
          const text2 = this.$t('Image height must be equal to')
          this.alertError({ text: `${text1} ${imageDimensions.height}px. ${text2} ${MAX_HEIGHT}px` })
        } else {
          this.configurationFormData.rightBannerImageURL = ''

          const formData = new FormData()
          if (typeof this.imageFormData.rightBannerImageURL !== 'string') {
            formData.append('attachedFile', this.imageFormData.rightBannerImageURL)
            formData.append('filetype', 'Others')
            formData.append('referenceNumber', uuidv4())
          }
          const response = await this.uploadImageFile({ formData, permission: eChannelsPermission.CREATE_THEME })

          const { status, data } = await response
          if (status === 200 && data) {
            this.configurationFormData.rightBannerImageURL = data.url
            this.rightBannerImageURLLoadSpinner = false
          }
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const reasonText = this.$t('Image upload failed. Reason:')
          this.alertError({ text: `${reasonText} ${responseError.errorMessage}` })
        })
      } finally {
        this.rightBannerImageURLLoadSpinner = false
      }
    },
    async fetchThemeConfigurationSetup() {
      this.isBusy = true
      this.showSpinner = true
      this.hideModal('modal-filter')
      try {
        const response = await this.getThemeConfigurationSetup({ permission: eChannelsPermission.VIEW_THEME })
        const { status, data } = response
        if (status === 200 && data) {
          this.configurationFormData = {
            name: data.name,
            prefix: data.prefix,
            email: data.email,
            supportEmail: data.supportEmail,
            seoKeywords: data.seoKeywords,
            domainName: data.domainName,
            playStoreLink: data.playStoreLink,
            appStoreLink: data.appStoreLink,
            facebook: data.facebook,
            twitter: data.twitter,
            instagram: data.instagram,
            whatsappNumber: data.whatsappNumber,
            address: data.address,
            supportPhoneNumber: data.supportPhoneNumber,
            websiteUrl: data.websiteUrl,
            onboardingPageBackgroundURL: data.onboardingPageBackgroundURL,
            loginPageImageURL: data.loginPageImageURL,
            logoURL: data.logoURL,
            onboardingNavBackgroundImageURL: data.onboardingNavBackgroundImageURL,
            faviconURL: data.faviconURL,
            leftBannerImageURL: data.leftBannerImageUrl,
            rightBannerImageURL: data.rightBannerImageUrl,
            themePrimaryColor: data.themeColors.primaryColor,
            themeSecondaryColor: data.themeColors.secondaryColor,
            themeDisabledElementPrimaryColor: data.themeColors.disabledElementPrimaryColor,
            themeLightPrimaryColor: data.themeColors.lightPrimaryColor,
            themeLightSecondaryColor: data.themeColors.lightSecondaryColor,
            id: data.id,
            fontFamily: data.fontFamily || 'Inter',
            preferredLoginPage: data.preferredLoginPage || 'template-v1',
          }
          if (this.configurationFormData.id !== '') {
            this.$refs.themeSetupForm.activateAll()
          }
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
        this.showSpinner = false
      }
    },
    handleSubmit() {
      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('this Theme Setup?')
      this.confirm(this.configurationAction, { text: `${areYouSure} ${this.buttonAction} ${thisText}` })
    },
    async configurationAction() {
      try {
        this.isLoading = true
        if (this.configurationFormData.id === '') {
          this.buttonAction = this.$t('Save')
        } else {
          this.buttonAction = this.$t('Update')
        }
        const formData = {
          name: this.configurationFormData.name,
          prefix: this.configurationFormData.prefix,
          email: this.configurationFormData.email,
          supportEmail: this.configurationFormData.supportEmail,
          seoKeywords: this.configurationFormData.seoKeywords,
          domainName: this.configurationFormData.domainName,
          playStoreLink: this.configurationFormData.playStoreLink,
          appStoreLink: this.configurationFormData.appStoreLink,
          facebook: this.configurationFormData.facebook,
          twitter: this.configurationFormData.twitter,
          instagram: this.configurationFormData.instagram,
          whatsappNumber: this.configurationFormData.whatsappNumber,
          address: this.configurationFormData.address,
          supportPhoneNumber: this.configurationFormData.supportPhoneNumber,
          websiteUrl: this.configurationFormData.websiteUrl,
          onboardingPageBackgroundURL: this.configurationFormData.onboardingPageBackgroundURL,
          loginPageImageURL: this.configurationFormData.loginPageImageURL,
          logoURL: this.configurationFormData.logoURL,
          themePrimaryColor: this.configurationFormData.themePrimaryColor,
          themeSecondaryColor: this.configurationFormData.themeSecondaryColor,
          themeDisabledElementPrimaryColor: this.configurationFormData.themeDisabledElementPrimaryColor,
          themeLightPrimaryColor: this.configurationFormData.themeLightPrimaryColor,
          themeLightSecondaryColor: this.configurationFormData.themeLightSecondaryColor,
          onboardingNavBackgroundImageURL: this.configurationFormData.onboardingNavBackgroundImageURL,
          faviconURL: this.configurationFormData.faviconURL,
          leftBannerImageURL: this.configurationFormData.leftBannerImageURL,
          rightBannerImageURL: this.configurationFormData.rightBannerImageURL,
          fontFamily: this.configurationFormData.fontFamily || 'Inter',
          preferredLoginPage: 'template-v1',
        }
        const formDataUpdate = this.configurationFormData
        const response = this.buttonAction === 'Save'
          ? await this.createThemeConfiguration({ formData, permission: eChannelsPermission.CREATE_THEME })
          : await this.updateThemeConfiguration({
            formDataUpdate,
            permission: eChannelsPermission.UPDATE_THEME,
          })
        const { status } = response
        if (status === 200) {
          this.fetchThemeConfigurationSetup()
          this.hideModal('modal-lg')
          const requestText = this.$t('Your request to')
          const successText = this.$t('Theme Setup was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonAction} ${successText}` })
          this.isReadonly = true
          this.buttonLabel = this.$t('Edit')
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('Theme Setup, Reason:')
          this.alertError({ text: `${requestText} ${this.buttonAction} ${reasonText} ${responseError.errorMessage}` })
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-image-loginPageImageURL{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 720px;
    height: 1024px
}
.upload-image-OnboardingNavBackgroundImageURL{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 400px;
    height: 1024px
}
.upload-image-logoImageURL{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 200px;
    height: 200px
}
.upload-image-faviconImageURL{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 200px;
    height: 200px
}
.upload-left-right-banner-ImageURL{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 296px;
    height: 864px
}
.format {
    color: #999999 !important;
}
form input[type=file]{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.upload-instruction{
  padding-top: 22%;
  color: #000;
  text-align: center;
}
.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/base/bootstrap-extended/_include.scss';
@import '../../../../@core/styles/global.css';
</style>
